// extracted by mini-css-extract-plugin
export default {"logoNotifications":"ButtonNotifications_logoNotifications__mlt8b","newsNotifications":"ButtonNotifications_newsNotifications__qdANN"};